export default __webpack_public_path__ + "static/media/product16.b090242e.png";